/**
 * TypeScript types mirroring the component schemas in `openapi/scribe.yaml`.
 *
 * These are hand-authored (not codegen'd) but kept in 1:1 correspondence with the OpenAPI
 * document — field names, nullability, and enums all match. If you change the OpenAPI
 * contract, update this file in the same change.
 *
 * Ownership/authorization note: `owner_id` and similar fields represent the Entra `oid`
 * claim as surfaced by the backend, never the Cognito `sub` — see
 * docs/adr-001-shared-cognito-identity.md. This package treats it as an opaque UUID string.
 */
// ── enums shared with the DB schema (backend/migrations/001_init.sql) ──────────────
export const RECORDING_STATUSES = [
    "uploaded",
    "queued",
    "transcribing",
    "completed",
    "failed",
];
export const PRINCIPAL_TYPES = ["user", "team"];
export const RESOURCE_TYPES = ["recording", "folder"];
export const PERMISSION_LEVELS = ["viewer", "commenter", "editor", "owner"];
export const WEBHOOK_EVENTS = [
    "transcription.completed",
    "transcription.failed",
    "recording.shared",
    "summary.ready",
];
export const VOCAB_ENGINE_STATES = ["PENDING", "READY", "FAILED"];
export const TRANSCRIPTION_ENGINES = ["aws-transcribe", "whisper"];
/** `comparison` = the Whisper side of an engine "both" run: listed, never authoritative. */
export const TRANSCRIPT_KINDS = ["platform", "imported", "derived", "comparison"];
// ── job spec (stored verbatim in recordings.job_spec jsonb) ────────────────────────
/** Per-recording engine CHOICE (docs/specs/whisper-1.md §5.0) — distinct from
 * `TranscriptionEngine`, the producer id recorded on a transcript version. "aws" is the
 * default and what a job spec without `engine` means; "both" = AWS authoritative + a Whisper
 * comparison version. Offer only what `Me.transcription_engines` lists. */
export const ENGINE_CHOICES = ["aws", "whisper", "both"];
export const TRANSCRIPTION_MODES = ["batch", "streaming"];
// ── transcript export ───────────────────────────────────────────────────────────────
export const TRANSCRIPT_EXPORT_FORMATS = ["txt", "vtt", "md"];
/** Content-Type of the exported transcript file, keyed by requested format. */
export const TRANSCRIPT_EXPORT_CONTENT_TYPES = {
    txt: "text/plain",
    vtt: "text/vtt",
    md: "text/markdown",
};
/** Coerces a raw `AiArtifact.content` payload into `SummaryContent` with safe defaults
 * (`''`/`[]`) for missing or wrong-typed fields, mirroring the backend's `_coerce` discipline. */
export function asSummaryContent(content) {
    const str = (v) => (typeof v === "string" ? v : "");
    const strArray = (v) => (Array.isArray(v) ? v.filter((x) => typeof x === "string") : []);
    const actionItems = (v) => Array.isArray(v)
        ? v
            .filter((x) => typeof x === "object" && x !== null)
            .map((x) => ({
            item: str(x.item),
            owners: strArray(x.owners),
            due: typeof x.due === "string" ? x.due : null,
        }))
        : [];
    return {
        summary: str(content.summary),
        title: str(content.title),
        key_points: strArray(content.key_points),
        action_items: actionItems(content.action_items),
        topics: strArray(content.topics),
    };
}
export * from "./imports.js";
export * from './ondemand.js';
export * from "./support.js";
export * from "./voiceprints.js";
//# sourceMappingURL=index.js.map